import styled from 'styled-components';

import { gridSizes, media } from 'utils/style';

import CancelForm from 'components/ModalCancelOrder/Sections/CancelForm/container';

export default styled(CancelForm)`
  padding: 20px 32px;

  display: flex;

  flex-direction: column;
  justify-content: space-between;

  ${media.lessThan('extraSmall')`
    background: var(--white);
    padding: ${gridSizes('M')};
    padding-top: 12px !important;
    padding-bottom: 12px !important;
    border-radius: 2px;
  `};

  p {
    margin: 0;
  }

  label {
    width: 100%;
    margin-bottom: ${gridSizes('M')} !important;
  }

  textarea {
    margin: ${gridSizes('M')} 0px;
  }
  .commentContainer.hasCommentError {
    textarea {
      border: 1px solid var(--error900);
      margin-bottom: 0;
    }
    textarea::placeholder {
      color: var(--error900);
      opacity: 1;
    }
    p {
      color: var(--error900);
      margin-bottom: ${gridSizes('M')};
      font-size: 12px;
      line-height: 16px;
    }
  }
`;
